/* istanbul ignore file */
import React from 'react';
import { CreateBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import AssetBreadcrumbs from 'domain/finance/assets/shared/AssetBreadcrumbs';

const CreateAssetBreadcrumbs = () => {
  return (
    <AssetBreadcrumbs>
      <CreateBreadcrumbItem entity="Asset" />
    </AssetBreadcrumbs>
  );
};

export default CreateAssetBreadcrumbs;
